import { all, put, call, takeLatest, takeEvery } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import { Reading } from 'portal/components/Utilities/Readings/Interface'

import {
  addReadingFailure,
  editReadingFailure,
  deleteReadingFailure,
  readingsLoadSuccess,
  readingsLoadFailure,
  READINGS_LOAD,
  ADD_READING,
  EDIT_READING,
  DELETE_READING,
  ReadingsLoadAction,
  AddReadingAction,
  EditReadingAction,
  DeleteReadingAction
} from './actions'

function* readingsLoadSaga(action: ReadingsLoadAction) {
  const { accountId, projectId } = action

  try {
    let readings: Reading[] = []
    const response: { data: Reading[] } = yield call(() =>
      axios.get(
        `/accounts/${accountId}/projects/${projectId}/utilities/readings`,
        {}
      )
    )

    readings = response && response.data ? [...response.data] : []

    yield put(readingsLoadSuccess(accountId, projectId, readings))
  } catch (error) {
    console.error(error)
    yield put(readingsLoadFailure(accountId, projectId, error))
  }
}

const addReadingRequest = async action => {
  const {
    accountId,
    projectId,
    meterId,
    readingDateTime,
    actualValue,
    notes,
    isEstimated,
    hasRolledOver,
    reload,
    showSuccessNotification,
    showFailureNotification
  } = action

  const response = await axios
    .post(
      `/accounts/${accountId}/projects/${projectId}/utilities/meters/${meterId}/readings/register`,
      {
        readingDate: readingDateTime,
        actualValue,
        notes,
        isEstimated,
        hasRolledOver,
        reload,
        showSuccessNotification,
        showFailureNotification
      },
      {
        validateStatus: status => {
          if (status === 200 || status === 201 || status === 204) {
            reload()
            showSuccessNotification()
            return true
          }
          showFailureNotification()
          return false
        }
      }
    )
    .then(response => response)
    .catch(error => {
      return error
    })

  return response
}

function* addReadingSaga(action: AddReadingAction) {
  const { accountId, projectId } = action

  try {
    yield call(() => addReadingRequest(action))
  } catch (error) {
    yield put(addReadingFailure(accountId, projectId, error))
    console.error('ERROR:', error)
  }
}

function* editReadingSaga(action: EditReadingAction) {
  const {
    accountId,
    projectId,
    readingId,
    eTag,
    meterId,
    readingDateTime,
    actualValue,
    notes,
    isEstimated,
    hasRolledOver,
    reload,
    showSuccessNotification,
    showFailureNotification
  } = action
  try {
    yield call(() =>
      axios.put(
        `/accounts/${accountId}/projects/${projectId}/utilities/meters/${meterId}/readings/${readingId}`,
        {
          eTag,
          readingDate: readingDateTime,
          actualValue,
          notes,
          isEstimated,
          hasRolledOver
        },
        {
          validateStatus: status => {
            if (status === 200 || status === 201 || status === 204) {
              reload()
              showSuccessNotification()
              return true
            }
            showFailureNotification()
            return false
          }
        }
      )
    )
  } catch (error) {
    yield put(editReadingFailure(accountId, projectId, error))
  }
}

function* deleteReadingSaga(action: DeleteReadingAction) {
  const { accountId, projectId, meterId, readingId, eTag, reload } = action
  try {
    yield call(() =>
      axios
        .delete(
          `/accounts/${accountId}/projects/${projectId}/utilities/meters/${meterId}/readings/${readingId}`,
          { data: { eTag } }
        )
        .then(() => {
          reload()
        })
    )
  } catch (error) {
    yield put(deleteReadingFailure(accountId, projectId, readingId, error))
  }
}

export function* watch() {
  yield all([takeLatest(READINGS_LOAD, readingsLoadSaga)])
  yield takeEvery(ADD_READING, addReadingSaga)
  yield takeEvery(EDIT_READING, editReadingSaga)
  yield takeEvery(DELETE_READING, deleteReadingSaga)
}
